import { lazyWithPreloader } from '../../react-router/lazyWithPreloader';

export const [SummaryLandingPage, preloadSummaryLandingPage] = lazyWithPreloader(() =>
	import('./SummaryLandingPage').then((module) => ({
		default: module.SummaryLandingPage,
	})),
);
